import { render, staticRenderFns } from "./courselist.vue?vue&type=template&id=08c476b5&"
import script from "./courselist.vue?vue&type=script&lang=js&"
export * from "./courselist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports